import TransferOrderCard from './TransferOrderCard'

export default TransferOrderCard
